import { initMenu } from './modules/menu.js';
import { initMegamenu } from './modules/megamenu.js';
import { initAccordion } from './modules/accordion.js';
import { initDragScroll } from './modules/drag-scroll.js';
import { initScrollNext } from './modules/scroll-next.js';
import { initHeroSlider } from './modules/hero-slider.js';
import { initModals } from './modules/modal.js';
import { initContactForm } from './modules/contact-form.js';
import { initLangSwitcher } from './modules/lang-switcher.js';
import { initLazyVideo } from './modules/lazy-video.js';

document.addEventListener('DOMContentLoaded', () => {
  initMenu();
  initMegamenu();
  initAccordion();
  initDragScroll();
  initScrollNext();
  initHeroSlider();
  initModals();
  initContactForm();
  initLangSwitcher();
  initLazyVideo();
});
